import script from "./TabbarView.vue?vue&type=script&setup=true&lang=js"
export * from "./TabbarView.vue?vue&type=script&setup=true&lang=js"

import "./TabbarView.vue?vue&type=style&index=0&id=a465e516&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a465e516"]])

export default __exports__